export const TYPE_IMAGES = ['jpeg', 'jpg', 'png', 'gif', 'svg', 'webp'];
export const TYPE_IMAGES_THUMBNAIL = ['jpeg', 'jpg', 'png'];
export const TYPE_VIDEOS = ['mp4', 'webm', 'avi'];
export const TYPE_AUDIOS = ['mp3', 'm4a', 'aac', 'wav', 'ogg'];
export const ALLOWED_FILE_TYPES_EDITOR = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  'video/mp4',
  'video/webm',
  'video/x-msvideo',
  'audio/mpeg',
  'audio/ogg',
  'video/ogg'
];

export const ALLOWED_FILE_TYPES_THUMBNAIL = ['image/png', 'image/jpeg', 'image/jpg'];
export const ALLOWED_FILE_TYPES_PROFILE = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/svg+xml'
];

export const FILE_TYPES = {
  twygsImage: 'image/png, image/jpeg, image/jpg',
  twygsMediaLexicalEditor:
    'image/png, image/jpeg, image/jpg, image/gif, video/mp4, video/webm, audio/mpeg, video/x-msvideo, audio/ogg, video/ogg',
  twygsVideo: 'video/mp4, video/quicktime, video/m4v, video/3gp',
  twygsPdf: '.pdf,application/pdf',
  brandSafety: 'text/csv',
  profile: 'image/png, image/jpeg, image/jpg, image/gif, image/svg+xml'
};

export const MAX_FILE_SIZE_1 = 1000 * 1000; // 1MB in Bytes
export const MAX_FILE_SIZE_30 = 30 * 1000 * 1000; // 30MB in Bytes
export const MAX_FILE_SIZE_50 = 50 * 1000 * 1000; // 50MB in Bytes
export const MAX_FILE_SIZE_10 = 10 * 1000 * 1000; // 10MB in Bytes
export const MAX_FILE_SIZE_300 = 300 * 1000 * 1000; // 300MB in Bytes
export const MAX_FILE_SIZE_4000 = 4 * 1000 * 1000 * 1000; // 4GB in Bytes
export const MAX_FILE_RESIZE_IMAGE = 1000 * 1000; // 1MB in Bytes
export const MAX_VIDEO_DURATION_2H = 2 * 60 * 60; // 2 Hour in Seconds
export const CHUNK_SIZE = 50 * 1000 * 1000; // 50MB in Bytes

export const getContentType = (fileName) => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  if (!extension) return undefined;

  if (TYPE_IMAGES.includes(extension)) {
    return 'image/' + (extension === 'jpg' || extension === 'webp' ? 'jpeg' : extension); // Correct 'jpg' to 'jpeg'
  }

  if (TYPE_VIDEOS.includes(extension)) {
    return 'video/' + extension;
  }

  // Audios
  if (TYPE_AUDIOS.includes(extension)) {
    console.log('3');
    switch (extension) {
      case 'mp3':
        return 'audio/mpeg';
      case 'm4a':
        return 'audio/mp4';
      case 'aac':
        return 'audio/aac';
      case 'wav':
        return 'audio/wav';
      case 'ogg':
        return 'audio/ogg';
    }
  }
  // Fallback
  return 'application/octet-stream';
};

export const getContentTypeAvatar = (fileName) => {
  const extension = fileName.split('.').pop();
  if (!extension) {
    return;
  }
  if (TYPE_IMAGES.includes(extension)) {
    return 'image/' + extension;
  } else return `application/${extension}`;
};

export const handleFileNameExtension = (fileName, type) => {
  if (!fileName || !type) return null;

  // Remove spaces
  const sanitizedFileName = String(fileName).replace(/\s+/g, '');

  // Extract name without extension
  const name = sanitizedFileName.includes('.')
    ? sanitizedFileName.substring(0, sanitizedFileName.lastIndexOf('.'))
    : sanitizedFileName;

  let extension = '';

  if (ALLOWED_FILE_TYPES_EDITOR.includes(type)) {
    const fileType = String(type).split('/')[0];
    const fileExtension = String(type).split('/')[1];

    if (fileType === 'image') {
      // Convert all images except GIF to WebP
      extension = fileExtension === 'gif' ? 'gif' : 'webp';
    } else if (fileType === 'video') {
      // Handle video formats
      if (fileExtension === 'ogg' || fileExtension === 'webm') {
        extension = 'mp4';
      } else {
        extension = fileExtension;
      }
    } else if (fileType === 'audio') {
      // Handle audio formats
      extension = 'mp3';
    } else {
      extension = fileExtension;
    }
  } else {
    throw new Error('Invalid file type');
  }

  const str = `${name}.${extension}`;
  return str;
};

export const IMAGE_TYPE = {
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  GIF: 'image/gif',
  WEBP: 'image/webp'
};
